module.exports = __webpack_public_path__ + "static/Image_Asset_4-9abd08a5815a3e1aed2a5a8a4f1c5ec1.png";